import CreditCard from './credit_card';

class CreditCards {
  constructor(creditCardsJson) {
    this.creditCards = creditCardsJson.map(creditCardJson => new CreditCard(creditCardJson));
  }

  get hasCards() {
    return this.creditCards.length > 0;
  }

  findById(creditCardId) {
    return this.creditCards.find(creditCard =>
      creditCard.creditCardId === creditCardId);
  }

  nonSelectedCreditCards(selectedCreditCardId) {
    return this.creditCards.filter(creditCard =>
      creditCard.creditCardId !== selectedCreditCardId);
  }

  creditCardsInOrder(selectedCreditCardId) {
    const creditCardList = this.nonSelectedCreditCards(selectedCreditCardId).slice(0);
    const selectedCreditCard = this.findById(selectedCreditCardId);
    if (selectedCreditCard) {
      creditCardList.unshift(selectedCreditCard);
    }
    return creditCardList;
  }
}

export default CreditCards;



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/credit_cards.js